module.exports = __webpack_public_path__ + "img/3.42730a47.png";